module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "debug-race-creator"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "debug-race-creator__content"
  }, [_c('div', {
    staticClass: "debug-section"
  }, [_c('h4', [_vm._v("🚀 Bulk Race Creation")]), _vm._v(" "), _c('div', {
    staticClass: "debug-form-row"
  }, [_c('div', {
    staticClass: "debug-form-group"
  }, [_c('label', {
    staticClass: "debug-label"
  }, [_vm._v("Number of Races:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.numberOfRaces),
      expression: "numberOfRaces"
    }],
    staticClass: "debug-input",
    attrs: {
      "type": "number",
      "placeholder": "Enter number of races to create",
      "min": "1",
      "max": "50"
    },
    domProps: {
      "value": (_vm.numberOfRaces)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.numberOfRaces = $event.target.value
      }, _vm.clearMessages]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "debug-form-group"
  }, [_c('label', {
    staticClass: "debug-label"
  }, [_vm._v("Duration (minutes):")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.raceDuration),
      expression: "raceDuration"
    }],
    staticClass: "debug-input",
    attrs: {
      "type": "number",
      "placeholder": "Race duration in minutes",
      "min": "1",
      "max": "120"
    },
    domProps: {
      "value": (_vm.raceDuration)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.raceDuration = $event.target.value
      }, _vm.clearMessages]
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "debug-form-row"
  }, [_c('div', {
    staticClass: "debug-form-group debug-form-group--full"
  }, [_c('label', {
    staticClass: "debug-label"
  }, [_vm._v("Race Date:")]), _vm._v(" "), _c('date-field', {
    attrs: {
      "name": "raceDate"
    },
    on: {
      "input": _vm.clearMessages
    },
    model: {
      value: (_vm.selectedDate),
      callback: function($$v) {
        _vm.selectedDate = $$v
      },
      expression: "selectedDate"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "debug-buttons"
  }, [_c('button', {
    staticClass: "debug-btn debug-btn--primary",
    attrs: {
      "disabled": _vm.loading || !_vm.numberOfRaces || !_vm.raceDuration || !_vm.selectedDate
    },
    on: {
      "click": _vm.createTestRaces
    }
  }, [(_vm.loading) ? _c('span', [_vm._v("Creating " + _vm._s(_vm.currentRaceIndex) + "/" + _vm._s(_vm.numberOfRaces) + "...")]) : _c('span', [_vm._v("Create Test Races")])]), _vm._v(" "), _c('button', {
    staticClass: "debug-btn debug-btn--secondary",
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.clearAll
    }
  }, [_vm._v("\n          Clear Form\n        ")])]), _vm._v(" "), (_vm.successMessage) ? _c('div', {
    staticClass: "debug-alert debug-alert--success"
  }, [_vm._v("\n        " + _vm._s(_vm.successMessage) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.errorMessage) ? _c('div', {
    staticClass: "debug-alert debug-alert--error"
  }, [_vm._v("\n        " + _vm._s(_vm.errorMessage) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.progressMessages.length > 0) ? _c('div', {
    staticClass: "debug-progress"
  }, [_c('h5', [_vm._v("Creation Progress:")]), _vm._v(" "), _c('ul', {
    staticClass: "debug-progress-list"
  }, _vm._l((_vm.progressMessages), function(message, index) {
    return _c('li', {
      key: index,
      staticClass: "debug-progress-item"
    }, [_vm._v("\n            " + _vm._s(message) + "\n          ")])
  }), 0)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "debug-section"
  }, [_c('h4', [_vm._v("⚙️ Race Configuration Preview")]), _vm._v(" "), _c('div', {
    staticClass: "debug-config-preview"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "debug-config-item"
  }, [_c('span', {
    staticClass: "debug-config-label"
  }, [_vm._v("Date:")]), _vm._v(" "), _c('span', {
    staticClass: "debug-config-value"
  }, [_vm._v(_vm._s(_vm.formattedSelectedDate || 'Not set'))])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "debug-config-item"
  }, [_c('span', {
    staticClass: "debug-config-label"
  }, [_vm._v("Duration:")]), _vm._v(" "), _c('span', {
    staticClass: "debug-config-value"
  }, [_vm._v(_vm._s(_vm.raceDuration || 'Not set') + " minutes")])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4)])]), _vm._v(" "), _c('div', {
    staticClass: "debug-section"
  }, [_c('h4', [_vm._v("📊 Debug Information")]), _vm._v(" "), _c('div', {
    staticClass: "debug-info"
  }, [_c('div', {
    staticClass: "debug-info-item"
  }, [_c('span', {
    staticClass: "debug-label"
  }, [_vm._v("Trainer ID:")]), _vm._v(" "), _c('span', {
    staticClass: "debug-value"
  }, [_vm._v(_vm._s(_vm.trainer ? _vm.trainer.id : 'Loading...'))])]), _vm._v(" "), _c('div', {
    staticClass: "debug-info-item"
  }, [_c('span', {
    staticClass: "debug-label"
  }, [_vm._v("API Endpoint:")]), _vm._v(" "), _c('span', {
    staticClass: "debug-value debug-value--small"
  }, [_vm._v(_vm._s(_vm.apiEndpoint))])]), _vm._v(" "), _c('div', {
    staticClass: "debug-info-item"
  }, [_c('span', {
    staticClass: "debug-label"
  }, [_vm._v("Current Time:")]), _vm._v(" "), _c('span', {
    staticClass: "debug-value"
  }, [_vm._v(_vm._s(_vm.currentTime))])]), _vm._v(" "), _vm._m(5)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "debug-race-creator__header"
  }, [_c('h3', [_vm._v("🏁 Race Creator Debug")]), _vm._v(" "), _c('p', {
    staticClass: "debug-race-creator__subtitle"
  }, [_vm._v("Create Test Races for Development")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "debug-config-item"
  }, [_c('span', {
    staticClass: "debug-config-label"
  }, [_vm._v("Name Pattern:")]), _vm._v(" "), _c('span', {
    staticClass: "debug-config-value"
  }, [_vm._v("TEST_DO_NOT_JOIN_1, TEST_DO_NOT_JOIN_2, ...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "debug-config-item"
  }, [_c('span', {
    staticClass: "debug-config-label"
  }, [_vm._v("Type:")]), _vm._v(" "), _c('span', {
    staticClass: "debug-config-value"
  }, [_vm._v("LIVE (Medal)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "debug-config-item"
  }, [_c('span', {
    staticClass: "debug-config-label"
  }, [_vm._v("Description:")]), _vm._v(" "), _c('span', {
    staticClass: "debug-config-value"
  }, [_vm._v("Test race created by debug tool - DO NOT JOIN")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "debug-config-item"
  }, [_c('span', {
    staticClass: "debug-config-label"
  }, [_vm._v("Image URL:")]), _vm._v(" "), _c('span', {
    staticClass: "debug-config-value debug-config-value--small"
  }, [_vm._v("\n            https://sgp1.vultrobjects.com/liverun-bucket/spreaker-live/race-image/fc07872c-2254-4228-a9f5-6ba0eef9edd8.png\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "debug-info-item"
  }, [_c('span', {
    staticClass: "debug-label"
  }, [_vm._v("Debug Mode:")]), _vm._v(" "), _c('span', {
    staticClass: "debug-value debug-value--active"
  }, [_vm._v("Active")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45adc58a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Races/DebugRaceCreator.vue
// module id = 1703
// module chunks = 2